import { SESSION_EXPIRED_ERROR } from '@/assets/AppConstants';
import { HTTP_STATUS_6XX } from '@/assets/constants/Http';

const FIRST_BUSINESS_CODE = 600;

const listeners = new Set<() => void>();

export const onSessionExpired = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const isSessionExpiredResponse = (status?: number, code?: unknown) => {
  if (status !== SESSION_EXPIRED_ERROR) return false;
  if (typeof code !== 'number' || code < FIRST_BUSINESS_CODE) return true;
  return code === HTTP_STATUS_6XX.SESSION_EXPIRED;
};

export const notifySessionExpired = () => listeners.forEach((listener) => listener());
